export default __webpack_public_path__ + "static/media/350-3504887_web-designing-web-development-illustration-png-transparent-png.adfde3c5.png";